import { Navigate, Outlet } from 'react-router-dom';

export default function AdminProtectedRoute() {
  const token = localStorage.getItem('adminToken');

  if (!token) {
    return <Navigate to="/admin" replace />;
  }

  return <Outlet />;
}